/**
 * Transient live preview while the architect edits the missing-fact form.
 * Cleared on Apply, dismiss, or violation change.
 */
import type { EvaluatedElement } from "@vera/rules";
import type { Violation } from "@vera/shared";
import { create } from "zustand";

interface FactPreviewStore {
  violationId: string | null;
  violation: Violation | null;
  /** Merged element facts (model + saved + draft) driving the preview. */
  previewFacts: EvaluatedElement["facts"] | null;
  setPreview: (
    violationId: string | null,
    violation: Violation | null,
    previewFacts?: EvaluatedElement["facts"] | null
  ) => void;
  clear: () => void;
}

export const useFactPreviewStore = create<FactPreviewStore>(set => ({
  violationId: null,
  violation: null,
  previewFacts: null,
  setPreview: (violationId, violation, previewFacts = null) =>
    set({ violationId, violation, previewFacts }),
  clear: () => set({ violationId: null, violation: null, previewFacts: null }),
}));
